if (!customElements.get('wishlist-model')) {
  class WishlistModel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.getWishListData();

      window.addEventListener('beforeunload', () => {
        const hasCustomer = this.dataset.customer != '';
        if (hasCustomer) this.updateWishlistData();
      });
    }

    publicUpdateEvent() {
      publishEvent(PUB_SUB_EVENTS.wishlistSync, {
        source: 'wishlist-model',
        data: {}
      });
    }

    async getWishListData() {
      const customerId = this.dataset.customer;

      if (!customerId) {
        requirejs(['pubsub'], () => {
          this.publicUpdateEvent();
        })
        return;
      }

      try {
        const url = `https://qdn-wishlist.fly.dev/wishlist/get/${Number(customerId)}`;

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const wishlistObj = await response.json();
          const serverWishlist = wishlistObj?.metafield?.value;

          serverWishlist ? this.syncWishlistData(serverWishlist) : '';
        }
      } catch (error) {
        console.log(error);
      }

      this.publicUpdateEvent();
    }

    syncWishlistData(serverWishlist) {
      const localWishlist = localStorage.getItem('wishlist')?.split('||') || [];
      const serverWishlistArr = serverWishlist?.split('||') || [];

      const syncWishlist = [...new Set([...serverWishlistArr, ...localWishlist])].join('||');

      localStorage.setItem('wishlist', syncWishlist);
    }

    async updateWishlistData() {
      const url = 'https://qdn-wishlist.fly.dev/wishlist/add';
      const customerId = this.dataset.customer;
      const wishlistArr = localStorage.getItem('wishlist');
      if (!customerId || !wishlistArr) return;

      await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customerId: Number(customerId),
          wishlistArr: wishlistArr
        })
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  customElements.define('wishlist-model', WishlistModel);
}
